import React, {useContext, useEffect} from 'react';
import ReactDOM from 'react-dom';
import {PopupContainerContext} from '@src/contexts/PopupContainerContext';
import {IPopupContainerContext} from '@src/@interfaces/contexts/IPopupContainerContext';
import classnames from '@src/helpers/classnames';

type Props = React.ComponentProps<IPopupContainerContext['Portal']>;

export default function PopupPortal(props: Pick<Props, keyof Props>) {
    const {popupsWrapperRef, getLastOpenedPopup} = useContext(PopupContainerContext) ?? {};
    const {closePopup, display, popupName} = props;

    useEffect(() => {
        if (!display || !window || !window.document || !closePopup || !getLastOpenedPopup) {
            return;
        }

        const listener = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && getLastOpenedPopup() === popupName) {
                closePopup();
            }
        };

        document.addEventListener('keydown', listener);

        return () => {
            document.removeEventListener('keydown', listener);
        };
    }, [closePopup, display, getLastOpenedPopup, popupName]);

    if (!popupsWrapperRef?.current || !props.display) {
        return null;
    }

    const popup = <div className="popup-container__popup" ref={props.wrapperRef}>
        <div className={classnames('popup-container__popup-content', {
            'popup-container__popup-content--stick-to-top': props.stickPopupTo === 'top',
            'popup-container__popup-content--stick-to-bottom': props.stickPopupTo === 'bottom',
        })}>{props.children}</div>
    </div>;

    return ReactDOM.createPortal(popup, popupsWrapperRef.current);
}
